import { EscalationLevelDTO } from '@/generated'
import i18n from '@/i18n/i18n'

export const EscalationLevelDTOToDisplayRole = (escalationLevel: EscalationLevelDTO) => {
  switch (escalationLevel) {
    case EscalationLevelDTO.CREATED:
      return i18n.global.t('Created')
    case EscalationLevelDTO.FIRST_SHIFT:
      return i18n.global.t('First Shift')
    case EscalationLevelDTO.BACKUP_SHIFT:
      return i18n.global.t('Backup Shift')
    case EscalationLevelDTO.ALL_IN_HOSPITAL:
      return i18n.global.t('All in Hospital')
    case EscalationLevelDTO.TCC:
      return i18n.global.t('TCC')
    case EscalationLevelDTO.SENIOR_PHYSICIAN:
      return i18n.global.t('Senior Physician')
    case EscalationLevelDTO.EMERGENCY_TCC:
      return i18n.global.t('Emergency TCC')
    case EscalationLevelDTO.EMERGENCY_HOSPITAL:
      return i18n.global.t('Emergency Hospital')
    case EscalationLevelDTO.EMERGENCY_SENIOR_PHYSICIAN:
      return i18n.global.t('Emergency Senior Physician')
  }
}

export const EmergencyEscalationLevelDTOToDisplayRole = (escalationLevel: EscalationLevelDTO) => {
  switch (escalationLevel) {
    case EscalationLevelDTO.EMERGENCY_TCC:
      return i18n.global.t('Emergency TCC')
    case EscalationLevelDTO.EMERGENCY_HOSPITAL:
      return i18n.global.t('Emergency Hospital')
    case EscalationLevelDTO.EMERGENCY_SENIOR_PHYSICIAN:
      return i18n.global.t('Emergency Senior Physician')
  }
}
